import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OphQuillEditorComponent} from './oph-quill-editor.component';
import {QuillModule} from 'ngx-quill';

@NgModule({
  declarations: [OphQuillEditorComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, QuillModule.forRoot()],
  exports: [OphQuillEditorComponent, QuillModule],
})
export class OphQuillEditorModule {}
